import React, { useState } from 'react'
import PropTypes from 'prop-types'

// Components - imported
import { Avatar, Button } from '@material-ui/core';
import Alert from '../../../common/Alert';
import Logo from '../../../common/Logo';

// Icons
import AddAPhotoOutlinedIcon from '@material-ui/icons/AddAPhotoOutlined';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

const AddName = ({
    slideform1, 
    setSlideForm1,
    handleGoBack,
    formData,
    onChange,
    is_create_page
}) => {

    const { group_name } = formData;

    // Toggle the slideform state variable (go to next page in slide form)
    const todo = (e) => {
        setSlideForm1(!slideform1);
    }

    return (
        <div className="form-transition-element">

            {/* Display the heading */}
            {!is_create_page && (
                <div>
                    <h2>Create Group</h2>
                </div>
            )}

            {/* Input Box for Bio text */}
            <div className="modal__inputs" style={{flex:1, paddingLeft:'5px'}}>
                <h3>Name this group</h3>
                <input
                    type="text"
                    placeholder="Group's name..."
                    className="input"
                    name="group_name"
                    maxlength="50"
                    style={{width: '94%'}}
                    value={group_name}
                    onChange={e => onChange(e)}
                />
                
            </div>

            <Button 
                disabled={!group_name?.length > 0}
                onClick={todo}
                variant="outlined" 
                className={`sidebar__tweet ${group_name?.length > 0 ? 'black' : 'ghost'}`}
                fullWidth
            >
                Next
            </Button>

            <Button 
                onClick={(e) => handleGoBack(e)}
                variant="outlined" 
                className="sidebar__tweet heart"
                fullWidth
            >
                Go Back
            </Button>
        </div>
    )
}

AddName.propTypes = {

}

export default AddName
